import {
    AccountRecord,
    SocialMediaServiceEnum,
    useGetAuthorisationUrlQuery
} from '../../../api/client'
import SimpleLoader from '../../SimpleLoader'

type Props = {
    account: AccountRecord
}

/**
 * Starts the OAuth2 authorisation grant flow for Twitter.
 *
 * This is the simplest type of flow button: we just redirect the user to
 * a URL with our own button.
 */
function TwitterAuthorisationButton(props: Props) {
    const { account } = props
    const { data, loading } = useGetAuthorisationUrlQuery({
        variables: {
            socialMediaService: SocialMediaServiceEnum.Twitter,
            accountId: account.id,
            baseUrl: `${window.location.protocol}//${window.location.host}/`
        }
    })

    let authorisationUrl: string = data?.getAuthorisationUrl || ''
    return (
        <>
            {loading ? (
                <SimpleLoader loading={loading} />
            ) : (
                <a href={authorisationUrl} className={`text-primary-600 p-2 underline `}>
                    Authorise at Twitter.com
                </a>
            )}
        </>
    )
}

export default TwitterAuthorisationButton
